import { useMutate, UseMutateParams } from './useMutate';
import { httpPost } from '../../components/utils';
import { useCallback } from 'react';

export type UsePostParams<TData, TResponse = unknown, TError = unknown> = Omit<
    UseMutateParams<TData, TResponse, TError>,
    'method'
>;

export const usePost = <TData, TResponse = unknown, TError = unknown>(
    params: UsePostParams<TData, TResponse, TError>
) => {
    // @ts-ignore TODO: currently can't use the generics in `httpPut`, need to be removed when `httpPut` will support generics
    const { mutate, loading, error } = useMutate<TData, TResponse>({ ...params, method: httpPost });

    const post = useCallback((url: string, data: TData) => mutate(url, data), [mutate]);

    return {
        loading,
        error,
        post
    };
};
